/* ============================================================
   YUVENLIFE — Shop-Config  (Single Source of Truth, NON-SECRET)
   ------------------------------------------------------------
   DIES ist die EINZIGE Datei, die beim Anbinden des echten Shopify-Stores
   editiert wird:  Domain · Storefront-Token · Variant-GIDs · Selling-Plan-GIDs.

   Sicherheit: der Storefront-Access-Token ist PUBLISHABLE / öffentlich.
   Er darf im Browser stehen — er kann NUR unauthenticated_* (Produkte/Preise
   lesen, Cart/Checkout erstellen). Er kann KEINE Orders, KEINE Fremd-Kunden,
   KEINE Admin-Operationen. Der Admin-Token (shpat_…) gehört NUR nach
   /root/secrets/.env und NIEMALS hierher / in den Browser.

   Selling-Plan-/Variant-IDs sind beim Build noch unbekannt (Abo-App-Wahl +
   Produkt-Seeding laufen mit Wolfgang). Bis dahin: Platzhalter + Feature-Flag.
   ============================================================ */
window.YUVENLIFE_SHOP = Object.freeze({
  /* ── Verbindung ─────────────────────────────────────────── */
  shopDomain:      "dd448d-bc.myshopify.com",    // YuvenLife (admin.shopify.com/store/dd448d-bc)
  apiVersion:      "2026-04",                     // gepinnt; aktuell empfohlen (2025-07 sunset 2026-07; 2026-07 = breaking changes)
  storefrontToken: "a01fa38176cfb29a4bf7f1aadc506534", // public Storefront-Token (browser-safe, unauthenticated_*)
  countryCode:     "DE",
  currencyCode:    "EUR",

  /* ── Feature-Flags ──────────────────────────────────────── */
  flags: Object.freeze({
    subscriptionsEnabled: true,   // echtes Selling-Plan vorhanden (routine30 → Monthly subscription)
    livePrices:           true,   // Preise live aus Storefront laden; Fallback = .fallback unten
    debug:                false   // true → ausführliche console-Logs
  }),

  /* ── PLAN-Key → Shopify-Identität ───────────────────────────
     type "subscription" sendet sellingPlanId NUR wenn flags.subscriptionsEnabled.
     GIDs sind Platzhalter bis Kickoff — dann hier (und NUR hier) ersetzen. */
  map: Object.freeze({
    testen:    { type:"onetime",      variantGid:"gid://shopify/ProductVariant/54775408001353", sellingPlanGid:null },                              // 500ml einmal @79
    // routine30 → APPSTLE-Test (2026-07-04): NEUES Produkt YL-OIL-500 + Appstle-Plan (appId "appstle", Monthly, 0%).
    // Rollback auf Seal: variantGid 53975875060041 + sellingPlanGid gid://shopify/SellingPlan/692333216073
    routine30: { type:"subscription", variantGid:"gid://shopify/ProductVariant/54775408001353", sellingPlanGid:"gid://shopify/SellingPlan/692344717641" }, // YL-OIL-500 Monthly-Abo (Appstle)
    // starter3 = "paket 3 monate" → Variante "3 Monate 3×500ml" am ACTIVE-Produkt (additiv, auto-published, kaufbar).
    starter3:  { type:"onetime",      variantGid:"gid://shopify/ProductVariant/54872420286793", sellingPlanGid:null }, // Bundle: 3 × YL-OIL-500
    paket6:    { type:"onetime",      variantGid:"gid://shopify/ProductVariant/54871875715401", sellingPlanGid:null }, // Bundle: 6 × YL-OIL-500
    travel:    { type:"onetime",      variantGid:"gid://shopify/ProductVariant/54775408263497", sellingPlanGid:null }  // YL-OIL-100 @24,99
  }),

  // KATALOG-LÜCKE (2026-06-25): Shopify ACTIVE-Produkt = 1 Produkt, 2 Varianten (500ml@79, 100ml@24,99) + Abo (Monthly/2-Monats).
  // Prototyp-Kaufmodul hat starter3(3M/229€)+paket6(6M/395€) erfunden — existieren NICHT im Store. Mit Wolfgang klären.
  _katalogLuecke: Object.freeze({ missing:["paket6"], abo2Monats:"gid://shopify/SellingPlan/692333248841" }),

  /* ── Lokale Fallback-Daten (Titel/Meta IMMER von hier; Preise nur falls
        livePrices-Fetch fehlschlägt). Spiegelt das bisherige PLANS-Objekt. ── */
  fallback: Object.freeze({
    testen:    { title:"Einzelflasche",     meta:"500 ml · einzelkauf",            price:79.0,  ship:0 },
    routine30: { title:"Flexibles Abo",     meta:"500 ml · monatlich · flexibel",  price:79.0,  ship:0 },
    starter3:  { title:"Startpaket",        meta:"3 × 500 ml · einmalig",          price:219.0, ship:0 },
    paket6:    { title:"5+1 Paket",          meta:"6 × 500 ml · einmalig",                     price:395.0, ship:0 },
    travel:    { title:"travel size 100 ml",meta:"100 ml",                         price:24.9,  ship:0 }
  })
});
